import type {
  GetExternalAccountLinkedAccountsQuery,
  GetExternalAccountTxsQuery,
  GetLinksQuery,
  ListExternalAccountsQuery,
} from 'hooks/customerApi';
import type { Link } from 'hooks/internalApi';

export type OnboardLinkFormProps = {
  onCreate: (value: Link) => void;
};

export type IncreaseEnvironment = 'sandbox' | 'production';

type LinkConnection = GetLinksQuery['links'];
export type LinkNode = LinkConnection['nodes'][number];
// Types generated directly from graphql schema
export type LinkType = LinkNode['__typename'];

type ExternalAccountConnection = NonNullable<
  ListExternalAccountsQuery['link']
>['externalAccounts'];
export type ExternalAccountNode = ExternalAccountConnection['nodes'][number];

export const linkTypeToName: Record<LinkType, string> = {
  IncreaseLink: 'Increase',
  CustomLink: 'Custom',
  UnitLink: 'Unit',
  StripeLink: 'Stripe',
};

export type TxNode = NonNullable<
  NonNullable<GetExternalAccountTxsQuery['externalAccount']>['txs']['nodes']
>[number];

export type LinkedLedgerAccount = NonNullable<
  NonNullable<
    NonNullable<
      GetExternalAccountLinkedAccountsQuery['externalAccount']
    >['ledgerAccounts']
  >['nodes']
>[number];
